<script>
    import {createEventDispatcher} from "svelte";
    import {I_PEOPLE_TAG, people_tags} from "../stores/people_tags";
    import {objectifyArray} from "../../../../../lib/datatypes";
    import DisplayTags from "./DisplayTags.svelte";
    import TagAdder from "./TagAdder.svelte";
    import {sortCompareASC} from "../../../../../lib/utils";
    import Tag from "./Tag.svelte";

    const dispatch = createEventDispatcher();

    export let filter = [];
    let editing_filter_i = -1;

    const resetFilter = () => filter = [];
    const resetEditingFilter = () => editing_filter_i = -1;

    const addFilterRow = () => {
        filter.push({
            has: true,
            all_of: false,
            tag_ids: []
        });
        editing_filter_i = filter.length - 1;
    }

    const removeRow = i => {
        resetEditingFilter(); // to stop weirdness from changing filter length
        filter = filter.filter((el, n) => i !== n);
    }

    // const onItemClicked = id => {
    //     dispatch('tagClicked', {id:id});
    // }
    // const onDeleteClicked = id => {
    //     dispatch('deleteClicked', {id:id});
    // };

    const onDeleteTagClicked = tag_id => {
        filter[editing_filter_i].tag_ids = filter[editing_filter_i].tag_ids
            .filter(id => id !== tag_id)
            .sort(sortCompareASC)        // sorting to keep things tidy
    };
    const onAddTagClicked = tag_id => {
        console.log('AddTagClicked', tag_id, editing_filter_i, filter);
        filter[editing_filter_i].tag_ids = filter[editing_filter_i].tag_ids
            .filter(id => id !== tag_id) // do a filter step to remove it if it's already in the list - so no duplicates!
            .concat(tag_id)              // concat rather than push, as concat returns an array, push the item added
            .sort(sortCompareASC);       // sorting to keep things tidy
        console.log('filter row after', filter[editing_filter_i]);
    };
</script>

{#each filter as row, i}
    {#if i === editing_filter_i}
        <!-- EDITING -->
        <div class="my-4">

            <div class="my-2">
                <span class="isolate inline-flex rounded-md shadow-sm">
                    {#if row.has === false}
                    <button type="button" on:click={() => row.has = true} class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-400 hover:text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">HAS</button>
                    <button type="button" class="relative -ml-px inline-flex items-center rounded-r-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white ring-2 ring-inset ring-indigo-800 hover:bg-indigo-800 focus:z-10">DOES NOT HAVE</button>
                    {:else}
                    <button type="button" class="relative inline-flex items-center rounded-l-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white ring-2 ring-inset ring-indigo-800 hover:bg-indigo-800 focus:z-10">HAS</button>
                    <button type="button" on:click={() => row.has = false} class="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-400 hover:text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">DOES NOT HAVE</button>
                    {/if}
                </span>

                <span class="isolate inline-flex rounded-md shadow-sm">
                    {#if row.all_of === false}
                        <button type="button" class="relative inline-flex items-center rounded-l-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white ring-2 ring-inset ring-indigo-800 hover:bg-indigo-800 focus:z-10">ANY OF</button>
                        <button type="button" on:click={() => row.all_of = true} class="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-400 hover:text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">ALL OF</button>
                    {:else}
                        <button type="button" on:click={() => row.all_of = false} class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-400 hover:text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">ANY OF</button>
                        <button type="button" class="relative -ml-px inline-flex items-center rounded-r-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white ring-2 ring-inset ring-indigo-800 hover:bg-indigo-800 focus:z-10">ALL OF</button>
                    {/if}
                </span>
            </div>

            <div class="mb-1">
                <DisplayTags show_delete_buttons={true} tag_id_list={row.tag_ids.join(',')} on:deleteClicked={(e) => onDeleteTagClicked(e.detail.id)}></DisplayTags>
            </div>
            <TagAdder tag_id_list={row.tag_ids.join(',')} on:tagClicked={(e) => onAddTagClicked(e.detail.id)}></TagAdder>

            <div class="flex justify-end pt-8">
                <button on:click={resetEditingFilter}
                        type="button"
                        class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >Close</button>
            </div>
        </div>
    {:else}
        <!-- VIEWING -->
        <div class="flex items-center my-2">
            <div class="min-w-0 flex-1 flex items-start justify-between">
                <div on:click={() => removeRow(i)} class="mr-2 p-1 flex-shrink-0 font-medium text-white bg-red-500 rounded-md border border-transparent">
                    <svg class="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"></path>
                    </svg>
                </div>
                <div class="">
                    <div class="flex text-sm align-baseline">
                        <p class="truncate ml-1 flex-shrink-0 font-normal text-gray-700">{row.has ? 'HAS' : 'DOES NOT HAVE'}</p>
                        <p class="truncate ml-1 flex-shrink-0 font-normal text-gray-700">{row.all_of ? 'ALL OF' : 'ANY OF'}</p>
                    {#each row.tag_ids.map(id => objectifyArray(I_PEOPLE_TAG, $people_tags.lookup[id])) as tag (tag.id)}
                        <Tag display_tag={tag}></Tag>
                    {/each}
                    </div>
                </div>
                <div on:click={() => editing_filter_i = i} class="ml-2 p-1 flex-shrink-0 font-medium text-white bg-green-500 rounded-md border border-transparent">
                    <svg class="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
                    </svg>
                </div>
            </div>
        </div>
    {/if}
{/each}
<div class="flex justify-end pt-8">
    <button on:click={addFilterRow}
            type="submit"
            class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >Add</button>
</div>

<style></style>